// @generated by protoc-gen-es v2.9.0 with parameter "target=ts+js"
// @generated from file hivtest/v1/api.proto (package hivtest.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file hivtest/v1/api.proto.
 */
export const file_hivtest_v1_api = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message hivtest.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 0);

/**
 * Describes the message hivtest.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 1);

/**
 * Describes the message hivtest.v1.Dispense.
 * Use `create(DispenseSchema)` to create a new message.
 */
export const DispenseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 2);

/**
 * Describes the message hivtest.v1.TokenInfo.
 * Use `create(TokenInfoSchema)` to create a new message.
 */
export const TokenInfoSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 3);

/**
 * Describes the message hivtest.v1.GetLoginInfoRequest.
 * Use `create(GetLoginInfoRequestSchema)` to create a new message.
 */
export const GetLoginInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 4);

/**
 * Describes the message hivtest.v1.GetLoginInfoResponse.
 * Use `create(GetLoginInfoResponseSchema)` to create a new message.
 */
export const GetLoginInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 5);

/**
 * Describes the message hivtest.v1.ListVendingMachinesRequest.
 * Use `create(ListVendingMachinesRequestSchema)` to create a new message.
 */
export const ListVendingMachinesRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 6);

/**
 * Describes the message hivtest.v1.ListVendingMachinesResponse.
 * Use `create(ListVendingMachinesResponseSchema)` to create a new message.
 */
export const ListVendingMachinesResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 7);

/**
 * Describes the message hivtest.v1.Photo.
 * Use `create(PhotoSchema)` to create a new message.
 */
export const PhotoSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 8);

/**
 * Describes the message hivtest.v1.VendingMachineInfo.
 * Use `create(VendingMachineInfoSchema)` to create a new message.
 */
export const VendingMachineInfoSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 9);

/**
 * Describes the message hivtest.v1.FindVendingMachineRequest.
 * Use `create(FindVendingMachineRequestSchema)` to create a new message.
 */
export const FindVendingMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 10);

/**
 * Describes the message hivtest.v1.FindVendingMachineResponse.
 * Use `create(FindVendingMachineResponseSchema)` to create a new message.
 */
export const FindVendingMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 11);

/**
 * Describes the message hivtest.v1.DispenseTestKitRequest.
 * Use `create(DispenseTestKitRequestSchema)` to create a new message.
 */
export const DispenseTestKitRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 12);

/**
 * Describes the message hivtest.v1.DispenseTestKitResponse.
 * Use `create(DispenseTestKitResponseSchema)` to create a new message.
 */
export const DispenseTestKitResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 13);

/**
 * Describes the message hivtest.v1.QueryDispenseStatusRequest.
 * Use `create(QueryDispenseStatusRequestSchema)` to create a new message.
 */
export const QueryDispenseStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 14);

/**
 * Describes the message hivtest.v1.QueryDispenseStatusResponse.
 * Use `create(QueryDispenseStatusResponseSchema)` to create a new message.
 */
export const QueryDispenseStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 15);

/**
 * Describes the message hivtest.v1.SearchSuburbsRequest.
 * Use `create(SearchSuburbsRequestSchema)` to create a new message.
 */
export const SearchSuburbsRequestSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 16);

/**
 * Describes the message hivtest.v1.SearchSuburbsResponse.
 * Use `create(SearchSuburbsResponseSchema)` to create a new message.
 */
export const SearchSuburbsResponseSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 17);

/**
 * Describes the message hivtest.v1.SuburbInfo.
 * Use `create(SuburbInfoSchema)` to create a new message.
 */
export const SuburbInfoSchema = /*@__PURE__*/
  messageDesc(file_hivtest_v1_api, 18);

/**
 * Describes the enum hivtest.v1.TokenState.
 */
export const TokenStateSchema = /*@__PURE__*/
  enumDesc(file_hivtest_v1_api, 0);

/**
 * @generated from enum hivtest.v1.TokenState
 */
export const TokenState = /*@__PURE__*/
  tsEnum(TokenStateSchema);

/**
 * Describes the enum hivtest.v1.DispenseStatus.
 */
export const DispenseStatusSchema = /*@__PURE__*/
  enumDesc(file_hivtest_v1_api, 1);

/**
 * @generated from enum hivtest.v1.DispenseStatus
 */
export const DispenseStatus = /*@__PURE__*/
  tsEnum(DispenseStatusSchema);

/**
 * This service does not require authentication
 *
 * @generated from service hivtest.v1.VendingMachineService
 */
export const VendingMachineService = /*@__PURE__*/
  serviceDesc(file_hivtest_v1_api, 0);

/**
 * This service does not require authentication
 *
 * @generated from service hivtest.v1.LoginService
 */
export const LoginService = /*@__PURE__*/
  serviceDesc(file_hivtest_v1_api, 1);

/**
 * @generated from service hivtest.v1.HivTestService
 */
export const HivTestService = /*@__PURE__*/
  serviceDesc(file_hivtest_v1_api, 2);

